import MenuIcon from '@mui/icons-material/Menu'
import IconButton from '@mui/material/IconButton'
import SwipeableDrawer from '@mui/material/SwipeableDrawer'
import { useState } from 'react'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'
import DrawerContent from './DrawerContent'

const DrawerMenu = () => {
  const [isOpen, setIsOpen] = useState(false)

  const theme = useTheme()
  const isMDBreakpoint = useMediaQuery(theme.breakpoints.up('md'))

  const toggleDrawer =
    (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
      if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' ||
          (event as React.KeyboardEvent).key === 'Shift')
      ) {
        return
      }

      setIsOpen(open)
    }

  return (
    <>
      <IconButton
        onClick={toggleDrawer(true)}
        size="large"
        edge="start"
        color="inherit"
        aria-label="menu"
        sx={{ mr: 'auto', zIndex: 1 }}
      >
        <MenuIcon />
      </IconButton>
      <SwipeableDrawer
        variant={isMDBreakpoint ? 'permanent' : 'temporary'}
        anchor={'left'}
        open={isOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
        ModalProps={{
          container: document.getElementById('redwood-app'),
        }}
      >
        <DrawerContent toggleDrawer={toggleDrawer} />
      </SwipeableDrawer>
    </>
  )
}

export default DrawerMenu
